
<div class="card" *ngIf="containerDisplay === 'ROUNDLIST'">
    <button *ngIf="loggedInPlayerHasPaid" (click)="postRound()" >Post a Round</button>
    <div class="error" *ngIf="!loggedInPlayerHasPaid">You are not able to post rounds until your entry fee has been sent to the Commish he has marked you as paid.</div>
    <table>
        <tr>
            <th></th>
            <th colspan="3">Rounds</th>
            <th></th>
        </tr>
        <tr>
            <th>Player</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>Avg.</th>
        </tr>
        <tr *ngFor="let p of players">
            <td>{{p.firstName}} {{p.lastName}}</td>
        </tr>
    </table>
</div>

<app-post-individual-round *ngIf="containerDisplay === 'POSTINDIVIDUALROUND'" [leagueWeek]="leagueWeek" [loggedInPlayerId]="loggedInPlayerId" [paidPlayers]="paidPlayers" (scoresPosted)="scoresPosted()"></app-post-individual-round>

<button class="cancel" (click)="containerDisplay = 'ROUNDLIST'" *ngIf="containerDisplay != 'ROUNDLIST'">BACK TO LIST</button>